import { useMutation, useQueryClient } from "react-query";
import { QueryKey } from "./query-key.enum";
import { AxiosError } from "axios";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { getApiErrorMessage } from "@core/utility/get-error-message";
import { AuthenticationApiFp, SigninUserRequestDto } from "@api/api";
import { refreshHeaders } from "./auth-header";
import { apiConfig } from "./config.query";

export function useQyLogin(
  onSuccess?: ((data: any) => void | Promise<unknown>) | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: SigninUserRequestDto) => {
    showProgress();
    const operation = await AuthenticationApiFp(
      apiConfig
    ).authenticationControllerAuthenticate(payload);
    const response = (await operation()).data as any;
    return response["data"] as any;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      queryClient.invalidateQueries(QueryKey.Authentication);
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);
      if (onError) {
        onError(err);
      }
    },
  });
}

export function useQyRenew(
  onSuccess?: ((data: any) => void | Promise<unknown>) | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async () => {
    showProgress();
    const operation = await AuthenticationApiFp(
      apiConfig
    ).authenticationControllerRefresh(refreshHeaders());
    const response = (await operation()).data as any;
    return response["data"] as any;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      queryClient.invalidateQueries(QueryKey.Authentication);
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);
      if (onError) {
        onError(err);
      }
    },
  });
}
